<template>
  <u-deploy-panel>
    <template slot="title">
      {{ $t('title') }}
    </template>
    <template slot="content">
      <v-alert v-if="warning" type="warning" class="mt-5" border="left" colored-border>
        {{ warning }}
      </v-alert>
      <p>{{ $t('description') }}</p>
      <v-text-field v-model="namespace" class="mb-4" :label="$t('deployment_name')" :rules="namespaceRules" required />
    </template>
    <template slot="actions">
      <v-spacer />
      <v-btn text @click="$emit('cancel')">{{ $t('wizard.cancel') }}</v-btn>
      <v-btn text @click="$emit('prev')">{{ $t('wizard.prev') }}</v-btn>
      <v-btn color="primary" @click="createNamespace(namespace)"
        :disabled="this.namespaceRules.map(r => r(namespace)).some(x => typeof x === 'string')" :loading="pending"
        small>
        {{ $t('notice.create') }}
      </v-btn>
    </template>
  </u-deploy-panel>
</template>

<script>
import DeployPanelComponent from '@/components/deploy/Panel.vue'
import NetworkService from '@/services/network'

export default {
  data() {
    return {
      namespace: undefined,
      namespaceRules: [
        (n) => !!n || this.$t('error.namespace_required'),
        (n) => this.validateNamespace(n) || this.$t('error.namespace_invalid'),
        (n) => !this.namespaceIds.includes(n) || this.$t('error.namespace_exists')
      ],
      pending: false,
      warning: null
    }
  },
  props: {
    namespaces: Array
  },
  computed: {
    namespaceIds() {
      return this.namespaces.map(n => n.id)
    }
  },
  methods: {
    createNamespace(namespace) {
      if (!namespace || !this.validateNamespace(namespace)) {
        return
      }

      this.pending = true
      NetworkService.createNamespace(namespace)
        .then(() => {
          Promise.all([
            NetworkService.createToken(namespace, { value: { type: 'node' } }),
            NetworkService.createToken(namespace, {
              value: {
                id: 'vault',
                type: 'secret'
              }
            })
          ])
            .then(() => {
              this.$emit('cancel')
            })
            .catch(() => this.warning = this.$t('error.token_creation'))
        })
        .catch(() => this.warning = this.$t('error.namespace_creation'))
        .finally(() => {
          this.pending = false
        })
    },
    validateNamespace(namespace) {
      return /^[a-zA-Z0-9._-]{1,32}$/.test(namespace)
    }
  },
  components: {
    'u-deploy-panel': DeployPanelComponent
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Enter a deployment name",
    "deployment_name": "Deployment Name",
    "description": "Provide a unique name for this deployment; it will be used for later identification.",
    "error": {
      "namespace_creation": "Namespace creation failed",
      "namespace_required": "The namespace is required.",
      "namespace_invalid": "It must be at most 32 characters long and only contain letters, numbers, dots, dashes and underscores.",
      "namespace_exists": "Namespace exists",
      "token_creation": "Token creation failed"
    },
    "notice": {
      "create": "Create"
    }
  }
}
</i18n>
